// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".site-cards[data-v-71418364]{margin-bottom:32px}.card-container[data-v-71418364]{display:flex;justify-content:flex-start;flex-wrap:wrap;align-items:stretch}@media screen and (max-width: 768px){.card-container[data-v-71418364]{flex-direction:column}}.title[data-v-71418364]{color:#053053;font-size:16px;font-weight:700}.message[data-v-71418364]{margin-left:8px;color:#ea2c2b;font-size:16px;font-weight:700}", ""]);
// Exports
module.exports = exports;
